export default __webpack_public_path__ + "static/media/chem320.f5948fff.svg";